module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.prefixUploadClass
  }, [_c('div', {
    class: _vm.classes,
    on: {
      "click": _vm.$_onUploaderClick,
      "drop": function($event) {
        $event.preventDefault();
        return _vm.$_onUploaderDrop($event)
      },
      "dragover": function($event) {
        $event.preventDefault();
        _vm.dragOver = true
      },
      "dragleave": function($event) {
        $event.preventDefault();
        _vm.dragOver = false
      }
    }
  }, [_c('input', {
    ref: "input",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "multiple": _vm.multiple,
      "accept": _vm.accept,
      "type": "file"
    },
    on: {
      "change": _vm.$_onUploaderChange
    }
  }), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _vm._t("tip"), _vm._v(" "), (_vm.showUploadList) ? _c('t-upload-list', {
    attrs: {
      "files": _vm.fileList
    },
    on: {
      "on-file-remove": _vm.$_onUploadListFileRemove,
      "on-file-preview": _vm.$_onUploadListFilePreview
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15d2920a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/upload/upload.vue
// module id = 347
// module chunks = 0